import DOMPurify from 'dompurify';

const rxEmptyP = new RegExp(/<p><\/p>/, 'mg');

export const sanitizeHtml = (html: string): string =>
  DOMPurify.sanitize(html, { ADD_ATTR: ['target'] }).replace(rxEmptyP, '');
